import {useFormContext} from "react-hook-form";


export default function NumberInput({name, label, customProps}) {
  const {register, formState: {errors}} = useFormContext()
  const error = errors[name]

  return (
    <div className="mb-2">
      <label htmlFor={name} className="form-label">{label}</label>

      <input
        {...register(name)}
        {...customProps}
        className={`form-control ${!!error && 'is-invalid'}`}
        placeholder={label}
      />
      {!!error && (
        <div className="invalid-feedback">{error.message}</div>
      )}
    </div>
  )
}
